// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summaryPadding[data-v-371b0215] {
  padding-bottom: 10px;
}
.info-balance .entry-text[data-v-371b0215] {
  color: #545959 !important;
  font-style: italic;
  font-weight: bold;
  /*position: relative;*/
}
.mixed-balance .entry-text[data-v-371b0215] {
  color: #D43900 !important;
  /*position: relative;*/
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-entry.vue","webpack://./np-entry.vue"],"names":[],"mappings":"AACI;EACI,oBAAA;ACAR;ADEI;EACI,yBAAA;EACA,kBAAA;EACA,iBAAA;ECAN,sBAAsB;AACxB;ADEI;EACI,yBAAA;ECAN,sBAAsB;AACxB","sourcesContent":["\n    .summaryPadding {\n        padding-bottom: 10px;\n    }\n    .info-balance .entry-text {\n        color: #545959!important;\n        font-style: italic;\n        font-weight: bold;\n        /*position: relative;*/\n    }\n    .mixed-balance .entry-text {\n        color: #D43900 !important;;\n        /*position: relative;*/\n    }\n",".summaryPadding {\n  padding-bottom: 10px;\n}\n.info-balance .entry-text {\n  color: #545959 !important;\n  font-style: italic;\n  font-weight: bold;\n  /*position: relative;*/\n}\n.mixed-balance .entry-text {\n  color: #D43900 !important;\n  /*position: relative;*/\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
